import React, {Component} from 'react'

class SubHeader extends Component{
	render(){
		const { message } = this.props
		return (
			<div className="bv-subheader bv-subheader-bg" style={{ paddingTop: "2rem", paddingBottom: "2rem" }}>
				<div className="bv-container container">
					<div className="row">
						<div className="col-xs-12 col-md-12">
							<div className="bv-subheader-nav">
								{ message }
							</div>
						</div>	
					</div>	
				</div>	
			</div>	
		)
	}
}

export default SubHeader
